//
//
//
//
import echarts from 'echarts';
import tdTheme from './theme.json';
import { on, off } from '@/libs/tools';
echarts.registerTheme('tdTheme', tdTheme);
export default {
  name: 'ChartLine',
  props: {
    value: Object,
    text: String,
    lineName: String,
    subtext: String,
    legend: Array,
    series: Array,
    xAxis: Array
  },
  data: function data() {
    return {
      dom: null,
      option: {},
      index: 0
    };
  },
  watch: {
    series: {
      handler: function handler(newVal, oldVal) {
        if (this.dom) {
          if (newVal) {
            this.getDataInit();
          } else {
            this.getDataInit();
          }
        } else {
          this.init();
        }
      },
      deep: true
    }
  },
  methods: {
    resize: function resize() {
      this.dom.resize();
    },

    /**
     * 获取当前的选中状态
     */
    setSelectStatus3: function setSelectStatus3(index) {
      var legendSelect = {};

      for (var i in this.legend) {
        if (i == index) {
          legendSelect[this.legend[i]] = true;
        } else {
          legendSelect[this.legend[i]] = false;
        }
      }

      return legendSelect;
    },
    //温湿度信息
    setOption: function setOption(index) {
      var series = this.series[index].data;
      var wd = [];
      var sd = [];

      for (var i in series) {
        var list = series[i];
        wd.push(list[0]);
        sd.push(list[1]);
      }

      var data = [{
        name: '温度',
        type: 'line',
        key: 3,
        data: wd
      }, {
        name: '湿度',
        type: 'line',
        key: 3,
        data: sd
      }];
      var option = {
        title: {
          text: this.text,
          subtext: this.subtext,
          x: 'center'
        },
        legend: {
          data: this.legend
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.series.length > 0 ? this.series[index].xaxis : []
        },
        yAxis: [{
          type: 'value',
          name: '温度',
          axisLabel: {
            formatter: '{value}'
          }
        }, {
          type: 'value',
          name: '湿度',
          axisLabel: {
            formatter: '{value}'
          }
        }],
        series: data
      };
      return option;
    },
    getDataInit: function getDataInit() {
      var index = this.index;

      if (index === 0) {
        this.dom.setOption(this.setOption(index));
      } else if (index === 1) {
        this.dom.setOption(this.setOption1(index));
      } else if (index === 2) {
        this.dom.setOption(this.setOption2(index));
      } else if (index === 3) {
        this.dom.setOption(this.setOption3(index));
      } else {
        this.dom.setOption(this.setOption(index));
      }
    },
    init: function init() {
      this.dom = echarts.init(this.$refs.dom, 'tdTheme');
      this.dom.showLoading();
      this.dom.setOption(this.setOption(0));
      this.dom.hideLoading();
      on(window, 'resize', this.resize);
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {
    off(window, 'resize', this.resize);
  }
};